export default __webpack_public_path__ + "static/media/resume-lg.1861ac89.png";